import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useKaiContext } from "./KaiContext";
import { resolveScreenContext } from "./kaiScreenContext";

/**
 * Keeps KAI screen context in sync with the current dashboard route.
 */
export default function KaiScreenContextBridge() {
  const location = useLocation();
  const { setScreenContext } = useKaiContext();

  useEffect(() => {
    const base = resolveScreenContext(location.pathname);
    setScreenContext((prev) => {
      const next = { ...base };
      // Preserve template customizer fields while still on that route.
      if (base.screen === "template_customizer" && prev?.templateRepoName) {
        next.templateRepoName = prev.templateRepoName;
        if (prev.activeCustomizerSection) {
          next.activeCustomizerSection = prev.activeCustomizerSection;
        }
      }
      return next;
    });
  }, [location.pathname, setScreenContext]);

  return null;
}
